module.exports = function (game_mod) {
  var _game_mod$respondTo;
  var invite_obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var html = "<form class=\"arcade-wizard saito-overlay-size wide\">";
  var invite = null;
  var publicKey = null;
  if (invite_obj.invite) {
    invite = invite_obj.invite;
  }
  if (invite_obj.publicKey) {
    publicKey = invite_obj.publicKey;
  }
  var img = ((_game_mod$respondTo = game_mod.respondTo('arcade-games')) === null || _game_mod$respondTo === void 0 ? void 0 : _game_mod$respondTo.image) || '';
  html += "\n    <div class=\"arcade-wizard-container\">\n    \n      <!- ***Game thumbnail & options start*** -->\n      <div class=\"arcade-wizard-image\">\n        <img class=\"arcade-wizard-game-thumbnail\" src=\"".concat(img, "\">\n      </div>\n      <!- ***Game thumbnail & options end*** -->\n\n\n      <!- ***Game desc & title start*** -->\n      <div class=\"arcade-wizard-game-details  rs-create-game-desc-wrapper\">\n        <div class=\"arcade-wizard-title\">\n          <span><b>").concat(game_mod.returnName(), "</b></span>\n        </div>\n        <div class=\"arcade-wizard-description\">").concat(game_mod.description, "</div>\n      </div>\n      <!- ***Game desc & title end*** -->\n  ");
  html += "\n        <input type=\"hidden\" name=\"game\" value=\"".concat(game_mod.name, "\" />\n  ");
  html += "\n    </div>\n\n    <div class=\"arcade-wizard-controls\">\n  \n      <div class=\"settings\">\n        ".concat(game_mod.returnOptions(), "\n        <div id=\"arcade-advance-opt\"><div class=\"arcade-wizard-advanced-text saito-anchor\">advanced options...</div></div>\n      </div>\n\n      <div class=\"arcade-wizard-actions\">\n  ");
  if (game_mod.maxPlayers == 1) {
    /*html += `<select name="invite_type" style="display:none;">
                <option value="single" selected default></option>
               </select>
      `;*/

    html += "<button type=\"button\" id=\"game-invite-btn\" class=\"fat saito-button-primary game-invite-btn\" data-type=\"single\">Play</button>";
  } else {
    html += "\n          <div class=\"saito-multi-select_btn saito-select\">\n           <div class=\"saito-multi-select_btn_options saito-slct\">\n      ";
    if (publicKey) {
      html += "<button type=\"button\" class=\"saito-multi-btn  game-invite-btn\" data-type=\"direct\">next...</button>";
    } else {
      if (invite_obj.league) {
        html += "\n\t\t\t\t\t<button type=\"button\" class=\"saito-multi-btn  game-invite-btn\" data-type=\"open\">create public league invite</button>\n                \t\t\t <button type=\"button\" class=\"saito-multi-btn  game-invite-btn\" data-type=\"private\">create private league invite</button>\n\t\t\t\t";
      } else {
        html += "\n              \t\t\t\t<button type=\"button\" class=\"saito-multi-btn  game-invite-btn\" data-type=\"open\">create public invite</button>\n              \t\t\t\t<button type=\"button\" class=\"saito-multi-btn game-invite-btn\" data-type=\"private\">create private invite</button>\n         \t\t\t";
        if (game_mod !== null && game_mod !== void 0 && game_mod.can_play_async) {
          html += "<button type=\"button\" class=\"saito-multi-btn  game-invite-btn\" data-type=\"async\">create async invite</button>";
        }
      }
    }
    html += "</div>\n          </div>";
  }
  html += "\n      </div>\n\n    </div>\n  ";

  // support game publishers
  if (game_mod.publisher_message) {
    html += "<div id=\"arcade-game-publisher-message\" class=\"arcade-game-publisher-message\">\n      <span>NOTE: </span>".concat(game_mod.publisher_message, "</div>");
  }
  html += "</form>"; // overlay closing

  return html;
};